module.exports = __webpack_public_path__ + "img/Jump Casting38.312fb08c.jpg";